export default __webpack_public_path__ + "static/media/gabi.2cede272.jpg";